export default defineNuxtPlugin(() => {
  const TAG_ID = 'G-3CRN0X16H7'

  // Define dataLayer + gtag stub synchronously so window.gtag exists before any
  // page component mounts (SSR is disabled, so useHead injects scripts async).
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', TAG_ID)

  // Load the external gtag.js loader; queued dataLayer events are processed once ready.
  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${TAG_ID}`,
        async: true,
      },
    ],
  })
})
